import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(1turn);
  }
`;

interface ILoaderCircleProps {
  isVisible?: boolean;
  thickness?: LoaderCircleThickness;
}

export enum LoaderCircleThickness {
  Thin = 2,
  Thick = 6,
}

export const LoaderCircle = styled.div<ILoaderCircleProps>`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 50%;
  animation: ${rotate} 1s infinite linear;
  border: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (props: any): number => props.thickness || LoaderCircleThickness.Thick
    }
    px solid
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (props: any): string => props.theme.loader.lightColor
    };
  border-top-color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props: any): string => props.theme.loader.darkColor
  };
`;
